export default __webpack_public_path__ + "static/media/turtlelogo.f922f814.png";